import React, { useState } from "react";
import { TextInput } from "react-native";

import { PasswordInputProps } from "./PasswordInput.types";
import { FormInput } from "../form-input";

export const PasswordInput = React.forwardRef(
  (
    {
      onChangeText,
      value,
      label = "Password",
      state,
      message,
      disabled,
      classNames,
      placeholder,
      onSubmitEditing,
    }: PasswordInputProps,
    ref: React.ForwardedRef<TextInput>,
  ) => {
    const [isHidden, setIsHidden] = useState(false);
    return (
      <FormInput
        ref={ref}
        label={label}
        state={state}
        message={message}
        iconRight={{
          name: isHidden ? "visibility_off" : "visibility",
          size: 20,
          onPress: () => setIsHidden(!isHidden),
        }}
        input={{
          onChangeText,
          onSubmitEditing,
          textContentType: "password",
          secureTextEntry: !isHidden,
          disabled,
          classNames,
          value,
          placeholder,
        }}
      />
    );
  },
);
